import React from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';
import * as PropTypes from 'prop-types';
import { variant } from 'styled-system';

import sx from '../../internal/styles/sx';

const StyledTableRow = styled('tr', { shouldForwardProp })(
  css({
    borderTopWidth: 'table.row',
    borderTopStyle: 'table.row',
    borderColor: 'transparent',
    fontFamily: 'body',
    fontWeight: 'normal',
  }),
  variant({
    prop: 'hasBorderTop',
    variants: {
      true: {
        borderColor: 'neutrals.6',
      },
    },
  }),
  sx
);

const TableRow = React.forwardRef(({ hasBorderTop = true, ...rest }, ref) => (
  <StyledTableRow ref={ref} hasBorderTop={hasBorderTop} {...rest} />
));

TableRow.propTypes = {
  hasBorderTop: PropTypes.bool,
};

export default TableRow;
